import { css } from "@emotion/react"
import { ReactNode } from "react"

export const EmptyState = ({ children }: { children: ReactNode }) => {
    return (
        <p
            css={css`
                padding: 2em 0px;
                font-weight: bold;
                text-align: center;
            `}
        >
            {children}
        </p>
    )
}
